export function sortList({ order, list, setList }) {
  const sortedList = [...list].sort((a, b) =>
    order === "asc"
      ? a.product_name.localeCompare(b.product_name)
      : b.product_name.localeCompare(a.product_name)
  );
  setList(sortedList);
}
